import { colors } from '../tokens';

/** Matches repeated inline Pagination sx across Messages, Transactions, etc. */
const MuiPaginationItem = {
  styleOverrides: {
    root: {
      '&.MuiPaginationItem-circular': {
        backgroundColor: colors.background.paper,
      },
    },
    selected: {
      backgroundColor: `${colors.primary.main} !important`,
      color: colors.primary.contrastText,
      '&:hover': {
        backgroundColor: colors.primary.main,
        color: colors.primary.contrastText,
      },
    },
  },
};

export default MuiPaginationItem;
